import React, { lazy, Suspense } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import "./App.css";
import Home from "./Pages/Home";
import ScrollToTop from "./Components/ScrollToTop";
import scrollToHash from "./Components/scrollToHash";

const MentionsLegales = lazy(() => import("./Pages/MentionsLegales"));
const Particuliers = lazy(() => import("./Pages/Particuliers"));
const Professionnels = lazy(() => import("./Pages/Professionnels"));
const Contact = lazy(() => import("./Pages/Contact"));
const NotFound = lazy(() => import("./Pages/NotFound"));

function ScrollHandler() {
  const location = useLocation();

  React.useEffect(() => {
    if (location.hash) {
      scrollToHash();
    }
  }, [location]);

  return null;
}

function App() {
  return (
    <div className="App">
      <Router>
        <ScrollToTop />
        <ScrollHandler />

        <Suspense fallback={null}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/mentions-legales" element={<MentionsLegales />} />
            <Route path="/particuliers" element={<Particuliers />} />
            <Route path="/professionnels" element={<Professionnels />} />
            <Route path="/contact" element={<Contact />} />

            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>

      </Router>
    </div>
  );
}

export default App;
